"use client";

import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { auth } from "@/app/lib/firebase";
import { showToast } from "@/app/lib/toast";
import { isAdmin, isAdminEmail } from "@/app/lib/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/app/lib/firebase";

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) {
        router.replace("/login");
        setLoading(false);
        return;
      }

      // Provjeri da li je nalog označen kao obrisan u deletedUsers
      try {
        const deletedRef = doc(db, "deletedUsers", u.uid);
        const deletedSnap = await getDoc(deletedRef);
        if (deletedSnap.exists()) {
          // Ako je nalog obrisan, odmah odjavi korisnika i blokiraj pristup
          await auth.signOut();
          showToast.error("Ovaj nalog je obrisan. Registruj novi nalog za pristup aplikaciji.");
          router.replace("/login");
          setLoading(false);
          return;
        }
      } catch (error) {
        console.warn("[RequireAuth] Error checking deletedUsers:", error);
      }

      // Initialize FCM token if notifications are enabled
      if (typeof window !== "undefined" && "Notification" in window) {
        // Check notification settings and request permission if needed
        import("../lib/storage").then(async ({ areNotificationsEnabled, getAndSaveFCMToken }) => {
          try {
            const enabled = await areNotificationsEnabled();
            if (enabled && Notification.permission === "granted") {
              // Automatically save FCM token when user is authenticated and notifications are enabled
              await getAndSaveFCMToken();
            }
          } catch (error) {
            console.error("Error initializing FCM token:", error);
          }
        });
      }

      setLoading(false);
    });
    return () => unsub();
  }, [router]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <div className="text-sm text-[var(--muted)]">Učitavanje…</div>
      </div>
    );
  }

  return <>{children}</>;
}
